module.exports = __webpack_public_path__ + "img/img3.88a91cd7.jpg";